@if (enableFilePreviewer) {
  <div class="file-preview__uploaded-document">
    @for (file of myFiles; track file) {
      <skychute-uploaded-document
        [data]="file"
        [isLoading]="file.uploadingInProgress"
        [isReadOnly]="file.uploadingInProgress"
        (deleteFile)="fileRemove.emit(file)"
      ></skychute-uploaded-document>
    }
  </div>
}
